import { createApiConstants } from '@saucelabs/sl-util-redux';

export const NAMESPACE = 'team-management/invitations';

export const TOGGLE_LOADING = `${NAMESPACE}/TOGGLE_LOADING`;
export const TOGGLE_INVITATION_SELECTION = `${NAMESPACE}/TOGGLE_INVITATION_SELECTION`;
export const CLEAR_INVITATION_SELECTION = `${NAMESPACE}/CLEAR_INVITATION_SELECTION`;
export const UPDATE_FILTER = `${NAMESPACE}/UPDATE_FILTER`;
export const UPDATE_OFFSET = `${NAMESPACE}/UPDATE_OFFSET`;

const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const INVITATION_LIST_GET = createApiNamespacedConstants('INVITATION_LIST_GET');
export const INVITATION_RENEW = createApiNamespacedConstants('INVITATION_RENEW');
export const INVITATION_REVOKE = createApiNamespacedConstants('INVITATION_REVOKE');
